"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeVoidNode = void 0;
var slate_1 = require("slate");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var normalizeVoidNode = function (node, path, editor) {
    if (node.children.length === 1 && slate_1.Text.isText(node.children[0]) && slate_1.Node.string(node).length === 0) {
        return false;
    }
    else if (node.children.length < 1) {
        slate_1.Transforms.insertNodes(editor, TokenModels_1.default.text.createSlateJson(""), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false), voids: true });
        return true;
    }
    else {
        slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length - 1], false), voids: true });
        return true;
    }
};
exports.normalizeVoidNode = normalizeVoidNode;
